export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getInitial = (string) => {
  return capitalizeFirstLetter(string).charAt(0);
};
